import { Directive } from '@angular/core';

@Directive({
  selector: '[tdWbCardMedia]',
  host: {
    'class': 'td-wb-card-media'
  }
})
export class CardMediaDirective {
}
